import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13639_1014)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.75 10.6182H18.5",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.75 13.6182H18.5",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.75 4.61816H4.25C3.83579 4.61816 3.5 4.95395 3.5 5.36816V18.8682C3.5 19.2824 3.83579 19.6182 4.25 19.6182H20.75C21.1642 19.6182 21.5 19.2824 21.5 18.8682V5.36816C21.5 4.95395 21.1642 4.61816 20.75 4.61816Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.5 13.6182C10.7426 13.6182 11.75 12.6108 11.75 11.3682C11.75 10.1255 10.7426 9.11816 9.5 9.11816C8.25736 9.11816 7.25 10.1255 7.25 11.3682C7.25 12.6108 8.25736 13.6182 9.5 13.6182Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.5 15.8682C6.83281 14.5744 8.10219 13.6182 9.5 13.6182C10.8978 13.6182 12.1681 14.5735 12.5 15.8682",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13639_1014",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.5 0.118164)"
		})
	}) })]
});
export default SvgIdIcon;
